import React from 'react'
import '../stylesheets/inventory.sass'
import { ScrollSyncPane } from 'react-scroll-sync'
import _ from 'lodash'

const IndexHeaders = (props) => {
  return (
    <div className='inventory_index_header'>
      <div className='inventory_index_header_wrapper'>
        <div className='column-one created_at_header'>
          <div style={{ 'fontWeight': 400 }}>
            Product
          </div>
        </div>
        <ScrollSyncPane>
          <div className='scroll'>
          { props.kegSizes && props.kegSizes.map( kegSize => {
              return (
              <div
                style={{ minWidth: 200, width: `${100/props.kegSizes.length}%` }}
                key={ kegSize['id'] }
                className='inventory_header'>
                <div>
                { _.startCase(kegSize['size']) }
                </div>
              </div>
              )
            })
          }
          </div>
        </ScrollSyncPane>
      </div>
    </div>
  )
}

export default IndexHeaders



// WEBPACK FOOTER //
// ./src/Inventory/IndexHeaders.js